module.exports = __webpack_public_path__ + "public/images/generated-algebra.8ecc5317bf485bc171cf47849ab6facc.jpg";